/**
 * Деньги и проценты в подписях кабинета: «5 900 ₸», «−500 ₸», «−20 %».
 *
 * Разряды и знак отделены неразрывным пробелом: в узкой колонке таблицы
 * «5 900 ₸» не должно разъезжаться на «5» и «900 ₸» по разным строкам.
 * Группировка своя, а не `toLocaleString`: разделитель разрядов у ICU
 * меняется от версии к версии, а подпись цены — одна на весь кабинет.
 */

const NBSP = ' ';

/** Типографский минус: дефис рядом с цифрами читается как тире. */
const MINUS = '−';

/** Целое число с разрядами: 1234567 → «1 234 567». */
function groupDigits(value: number): string {
  return String(Math.abs(Math.round(value))).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
}

/** «5 900 ₸». Ноль — тоже цена: «0 ₸», а не пустота. */
export function formatTenge(value: number): string {
  const sign = Math.round(value) < 0 ? MINUS : '';
  return `${sign}${groupDigits(value)}${NBSP}₸`;
}

/** Скидка суммой: «−500 ₸». */
export function formatTengeOff(value: number): string {
  return `${MINUS}${groupDigits(value)}${NBSP}₸`;
}

/** «23 %». */
export function formatPercent(value: number): string {
  return `${Math.round(value)}${NBSP}%`;
}

/** Скидка процентом: «−20 %». */
export function formatPercentOff(value: number): string {
  return `${MINUS}${Math.round(Math.abs(value))}${NBSP}%`;
}
